<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div v-if="loaded" class="main-offer-card">
      <div class="summary-header">
        <div class="summary-title">
          <div class="summary-icon-sample-details"></div>
          <div class="summary-text">{{ $t('sample_detail') }}</div>
        </div>

        <div class="summary-actions">
          <button
            class="download-button"
            :disabled="currentSampleSummary.status_code !== '3'"
            @click="$refs.sampleSummary.download()"
          >
            {{ $t('download') }}
          </button>
        </div>
      </div>
      <div v-if="!isFinished" class="warning-message">
        {{ $t('provisionalResultsMessage') }}
      </div>

      <div class="sample-summary-card">
        <!-- <EnvironmentSampleSummary :count="cmaCount" /> -->
        <EnvironmentSampleSummary
          ref="sampleSummary"
          :count="cmaCount"
        />
      </div>
      <br />
      <EnvironmentSamplesDetailsTable
        v-if="showDetails"
        class="custom-table-container-enviroment tableContainerenviroment"
        :store="customStore"
      />

      <NotificationSpinner
        v-if="!showDetails"
        :message="$t('pendingPaymentSampleResult')"
        :alert="true"
      />

      <!-- <NotificationSpinner
        v-if="inProcess"
        :message="$t('inProcessSampleResult')"
        :warning="true"
      /> -->
    </div>
  </f7-page>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import EnvironmentSampleSummary from '@/components/Environment/SamplesDetails/Summary/index.vue';
import EnvironmentSamplesDetailsTable from '@/components/Environment/SamplesDetails/Table/index.vue';
import EventBus from '@/services/event-bus';
import NotificationSpinner from '@/components/NotificationSpinner/index.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'EnvironmentSamplesDetailsPage',
  components: {
    EnvironmentSamplesDetailsTable,
    EnvironmentSampleSummary,
    NotificationSpinner,
  },
  data() {
    return {
      loaded: false,
      customStore: null,
      cmaCount: {
        apts: 0,
        no_apts: 0,
        total: 0,
      },
      currentSampleSummary: {},
    };
  },
  computed: {
    urlName() {
      if (this.lastRouteEnvStats) {
        return 'EnvironmentStatsPage';
      }
      // Si accede al detalle de una muestra desde una factura, vuelve al listado de facturas
      if (this.lastRouteIssuedInvoicesList) {
        return 'issuedInvoicesList';
      }
      return this.lastRouteHome ? 'Home' : 'EnvironmentSamplesPage';
    },
    showDetails() {
      return this.currentSampleSummary?.status_code !== '5';
    },
    inProcess() {
      return this.currentSampleSummary?.status_code === '2';
    },
    isFinished() {
      return this.currentSampleSummary?.status_code === '3';
    },
    ...mapState('filter', ['currentSampleId']),
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteEnvStats',
      'lastRouteIssuedInvoicesList',
    ]),
  },
  async beforeMount() {
    try {
      this.loaded = false;
      this.currentSampleSummary =
        await this.getCurrentSampleBasedOnFilter();
      this.cmaCount = await this.getCmaAptCount();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  async mounted() {
    try {
      this.loaded = false;
      EventBus.$on(
        'environmentDetailsFilteredSamples',
        async ({ id, params }) => {
          if (params) {
            this.customStore = await this.getStoreDetailsWithFilters({
              id,
              paramFilters: params,
            });
          } else {
            this.customStore = await this.getDetailsStore();
          }
        }
      );

      this.customStore = await this.getDetailsStore();
    } catch (error) {
      this.customStore = null;
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }

    // if (!this.showDetails) {
    //   this.$notifyDX(
    //     {
    //       message: this.$t('pendingPaymentSampleResult'),
    //       width: 550,
    //     },
    //     'warning',
    //     7000
    //   );
    // }
  },
  methods: {
    ...mapActions('samples', ['getEnvironmentSampleDetails']),
    ...mapActions('environmentSamples', [
      'getDetailsStore',
      'getStoreDetailsWithFilters',
      'getCmaAptCount',
    ]),
    ...mapActions('filter', ['setCurrentFilter']),
    ...mapActions('samples', ['getCurrentSampleBasedOnFilter']),
  },
};
</script>

<style>
.main-offer-card {
  background-color: white; /* fondo gris suave */
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(87, 84, 95, 0.3);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: clip;
}
.summary-title {
  gap: 10px;
  margin-bottom: 16px;
}

.summary-icon-sample-details {
  width: 24px;
  height: 24px;
  background-image: url('@/static/icons/ic_detalle_muestra.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.summary-text {
  font-size: 18px;
  font-weight: 600;
  color: #00346a; /* o el color que uses para encabezados */
}

.tableContainerenviroment {
  background: var(--Basic-White, #fff) !important;
  border-radius: 10px !important;
}
.tableContainerenviroment > div[style*='position: absolute'] {
  right: 70px !important; /* arrastra el botón como el de subir de documentación */
}

.custom-table-container {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  box-sizing: border-box;
}

.summary-header {
  margin-bottom: 16px;
}

.summary-title {
  gap: 10px;
}

.summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Botón “Descargar” fuera del card */
.download-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #00346a;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 10px;
  padding: 10px 14px 10px 30px;
  cursor: pointer;
  width: 120px;
  background-repeat: no-repeat;
  background-position: 10px center;
  background-size: 16px;
  background-image: none !important;
}

.download-button:hover {
  background-color: #004b93;
}
.summary-actions .download-button {
  transform: translateY(
    -6px
  ); /* súbelo ligeramente para alinearlo con el icono */
}

.warning-message {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #bc5b00;
  background: #fff2e5;
  color: #bc5b00;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  padding: 8px 16px 8px 42px;
  margin-bottom: 24px; /* solo margen inferior */
  background-image: url('@/static/icons/warning.svg');
  background-repeat: no-repeat;
  background-size: 20px;
  background-position: 14px center;
  width: 100%; /* ocupa todo el ancho disponible */
  box-sizing: border-box;
}

.download-button:disabled {
  background-color: #e5e4e7; /* gris claro como en Figma */
  color: #8a8693; /* gris del texto e icono */
  cursor: not-allowed;
  border: 1px solid #8a8693; /* borde fino gris */
  filter: none; /* evita efectos de hover */
  opacity: 1; /* mantiene visibilidad */
}

.download-button::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 18px;
  transform: translateY(-50%);
  width: 24px; /* tamaño del icono */
  height: 24px;
  background-image: url('@/static/icons/download.svg');
}

.summary-actions .download-button {
  font-weight: 600 !important;
}
</style>
